import React from "react"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import IconButton from "@mui/material/IconButton"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography"
import CloseIcon from "@mui/icons-material/Close"

import { I18n, Translate } from "utils/i18n-shim"

export const JoyrideMuiTooltip = ({
  index,
  isLastStep,
  size,
  step,
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  tooltipProps
}) => (
  <Paper
    {...tooltipProps}
    elevation={8}
    sx={{ maxWidth: 380, p: 3, outline: "none" }}
  >
    {step.title && (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          mb: 1
        }}
      >
        <Typography
          variant="h6"
          sx={{ fontWeight: 600, fontSize: "1.1rem", lineHeight: 1.3 }}
        >
          {step.title}
        </Typography>
        <IconButton
          {...closeProps}
          size="small"
          sx={{ ml: 1, mt: -0.5 }}
          aria-label={I18n.t("joyride.actions.close")}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    )}

    <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
      {step.content}
    </Typography>

    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}
    >
      <Button
        {...skipProps}
        size="small"
        color="inherit"
        sx={{ color: "text.secondary" }}
      >
        <Translate value="joyride.actions.skip" />
      </Button>

      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <Typography variant="caption" sx={{ color: "text.secondary" }}>
          {index + 1} / {size}
        </Typography>

        {index > 0 && (
          <Button
            {...backProps}
            size="small"
            variant="outlined"
            color="primary"
            disableRipple
          >
            <Translate value="joyride.actions.back" />
          </Button>
        )}

        <Button
          {...primaryProps}
          size="small"
          variant="contained"
          color="primary"
          disableRipple
        >
          <Translate
            value={isLastStep ? "joyride.actions.last" : "joyride.actions.next"}
          />
        </Button>
      </Box>
    </Box>
  </Paper>
)
